<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="名称" prop="title">
                <el-input style="width:480px;" v-model="form.title" placeholder="请输入Guide名称"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sortOrder">
                <el-input style="width:480px;" v-model="form.sortOrder" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="站点" prop="siteIdList">
                <el-select v-model="form.siteId" placeholder="请选择适用站点">
                    <el-option v-for="item in countries" :key="item.id" :label="item.siteName"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <el-radio-group v-model="form.type">
                    <el-radio-button label="1">GIF</el-radio-button>
                    <el-radio-button label="2">视频</el-radio-button>
                    <el-radio-button label="3">富文本</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.type == '1'" label="GIF图片" prop="content">
                <UploaderImage v-model="form.content"></UploaderImage>
            </el-form-item>
            <el-form-item v-if="form.type == '2'" label="视频" prop="content">
                <UploaderVideo style="width:680px;" v-model="form.content"></UploaderVideo>
            </el-form-item>
            <el-form-item v-if="form.type == '3'" label="富文本" prop="content">
                <Editor v-model="form.content"></Editor>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/guide";
import { upload } from "@/api/upload";
import { page } from "@/api/site";
import UploaderVideo from "@/components/UploaderVideo.vue";
import UploaderImage from "@/components/UploaderImage.vue";
import Editor from "@/components/Editor.vue";

export default {
    components: { UploaderVideo, UploaderImage, Editor },
    data() {
        return {
            id: null,
            form: {
                title: "",
                sortOrder: "",
                siteId: undefined,
                type: "1",
                content: ""
            },
            countries: [],
            rules: {
                title: [
                    { required: true, message: "请输入Guide名称", trigger: "blur" }
                ],
                sortOrder: [
                    { required: true, message: "请输入排序", trigger: "blur" }
                ],
                siteId: [
                    { required: true, message: "请选择适用站点", trigger: "change" }
                ],
                type: [
                    { required: true, message: "请选择类型", trigger: "change" }
                ],
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" }
                ]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            page({
                pageNum: 1,
                pageSize: 100
            }).then(({ code, data, message }) => {
                if (code == 200) {
                    this.countries = data.records;
                } else {
                    this.$message.error(message);
                }
            })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        ...data
                    };
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>